var render, staticRenderFns
import script from "./BColumn.vue?vue&type=script&lang=js&"
export * from "./BColumn.vue?vue&type=script&lang=js&"
import style0 from "./BColumn.vue?vue&type=style&index=0&id=1ac8b344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac8b344",
  null
  
)

export default component.exports